import { toast } from "react-toastify";
import { BRANCH_APPLICATIONS_ERROR, BRANCH_APPLICATIONS_LOADER, GET_ALL_ACTIVE_BRANCHES, GET_APPLICATIONS_SUMMARY, GET_BRANCH_APPLICATIONS } from "../actionType";
import axios from "axios";

export const getAllApplicationsForOfficer = (page, limit, filters) => async (dispatch) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        dispatch({ type: BRANCH_APPLICATIONS_ERROR });
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    }

    try {
        dispatch({ type: BRANCH_APPLICATIONS_LOADER });

        const queryParams = new URLSearchParams({
            page,
            limit,
            // filters: JSON.stringify(filters)
        });

        if(filters?.application_id){
            queryParams.append("application_id", filters?.application_id);
        }

        if(filters?.application_stage_name){
            queryParams.append("application_stage_name", filters?.application_stage_name);
        }

        if(filters?.current_application_bucket){
            queryParams.append("current_application_bucket", filters?.current_application_bucket);
        }

        if(filters?.application_status){
            queryParams.append("application_status", filters?.application_status);
        }

        if(filters?.application_owner){
            queryParams.append("application_owner", filters?.application_owner);
        }

        if(filters?.customer_name){
            queryParams.append("customer_name", filters?.customer_name);
        }

        if(filters?.customer_pan){
            queryParams.append("customer_pan", filters?.customer_pan);
        }

        if(filters?.phone_number){
            queryParams.append("phone_number", filters?.phone_number);
        }

        if(filters?.lead_id){
            queryParams.append("lead_id", filters?.lead_id);
        }

        if(filters?.seeds_id){
            queryParams.append("seeds_id", filters?.seeds_id);
        }
        
        if(filters?.external_customer_id){
            queryParams.append("external_customer_id", filters?.external_customer_id);
        }

        if(filters?.is_ro_completed){
            queryParams.append("is_ro_completed", filters?.is_ro_completed);
        }

        if(filters?.is_bm_completed){
            queryParams.append("is_bm_completed", filters?.is_bm_completed);
        }

        if(filters?.is_bcm_completed){
            queryParams.append("is_bcm_completed", filters?.is_bcm_completed);
        }

        if(filters?.is_rejected){
            queryParams.append("is_rejected", filters?.is_rejected);
        }

        if(filters?.sort_by){
            queryParams.append("sort_by", filters?.sort_by);
        }

        if(filters?.sort_order){
            queryParams.append("sort_order", filters?.sort_order);
        }

        if(filters?.global_search){
            queryParams.append("global_search", filters?.global_search);
        }

        if(filters?.start_date && filters?.end_date){
            queryParams.append("start_date", filters?.start_date);
            queryParams.append("end_date", filters?.end_date);
        }

        if (Array.isArray(filters?.ro_employee_ids)) {
            filters.ro_employee_ids.forEach(id => {
                queryParams.append("ro_employee_ids", id);
            });
        }

        if (Array.isArray(filters?.bm_employee_ids)) {
            filters.bm_employee_ids.forEach(id => {
                queryParams.append("bm_employee_ids", id);
            });
        }

        if (Array.isArray(filters?.bcm_employee_ids)) {
            filters.bcm_employee_ids.forEach(id => {
                queryParams.append("bcm_employee_ids", id);
            });
        }

        if(filters?.branch_code){
            queryParams.append("branch_code", filters?.branch_code);
        }

        // if(filters?.application_owner){
        //     queryParams.append("application_owner", filters?.application_owner);
        // }

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/applications/get-all-applications-via-app?${queryParams.toString()}`, { headers });
        // console.log("Response ====>", response?.data?.data);

        dispatch({ type: GET_BRANCH_APPLICATIONS, payload: response?.data?.data })

        sessionStorage.setItem('totalPages', response?.data?.data?.pagination?.totalPages || 1);
        sessionStorage.setItem('totalCount', response?.data?.data?.pagination?.total || 0);
        sessionStorage.setItem('currentPage', response?.data?.data?.pagination?.page || 1);
        sessionStorage.setItem('limit', response?.data?.data?.pagination?.limit || 10);
    }
    catch (err) {
        dispatch({ type: BRANCH_APPLICATIONS_ERROR });
        toast.error(`${err?.response?.data?.message}`);
    }
}

export const getApplicationsSummary = (filters={}) => async (dispatch) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        dispatch({ type: BRANCH_APPLICATIONS_ERROR });
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    }

    try {
        dispatch({ type: BRANCH_APPLICATIONS_LOADER });

        const queryParams = new URLSearchParams();

        if(filters?.startDate){
            queryParams.append("startDate", filters?.startDate);
        }

        if(filters?.endDate){
            queryParams.append("endDate", filters?.endDate);
        }

        if(filters?.branch_code){
            queryParams.append("branch_code", filters?.branch_code);
        }

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/applications/dashboard-summary?${queryParams.toString()}`, { headers });
        // console.log("Response ====>", response?.data?.data);

        dispatch({ type: GET_APPLICATIONS_SUMMARY, payload: response?.data?.data });
    }
    catch (err) {
        dispatch({ type: BRANCH_APPLICATIONS_ERROR });
        toast.error(`${err?.response?.data?.message}`);
    }
}

export const getAllActiveBranches = (page, limit, filters) => async (dispatch) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        dispatch({ type: BRANCH_APPLICATIONS_ERROR });
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    }

    try {
        dispatch({ type: BRANCH_APPLICATIONS_LOADER });

        const queryParams = new URLSearchParams({
            page,
            limit
        });

        if(filters?.state_name){
            queryParams.append("state_name", filters?.state_name);
        }

        if(filters?.branch_name){
            queryParams.append("branch_name", filters?.branch_name);
        }

        if(filters?.branch_code){
            queryParams.append("branch_code", filters?.branch_code);
        }

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/officer/get-branch-report?${queryParams.toString()}`, { headers });

        dispatch({ type: GET_ALL_ACTIVE_BRANCHES, payload: response?.data?.data?.branch_data });
    }
    catch (err) {
        dispatch({ type: BRANCH_APPLICATIONS_ERROR });
        toast.error("Error in fetching all active branches", err);
    }
}